import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebook,
  faYoutube,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

library.add(faFacebook, faInstagram, faYoutube, faBars, faTimes);
